import { render, staticRenderFns } from "./ServiceUnavailable.vue?vue&type=template&id=b2969e20&scoped=true&"
import script from "./ServiceUnavailable.vue?vue&type=script&lang=js&"
export * from "./ServiceUnavailable.vue?vue&type=script&lang=js&"
import style0 from "./ServiceUnavailable.vue?vue&type=style&index=0&id=b2969e20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2969e20",
  null
  
)

export default component.exports